import { http } from 'services/http';
import { CLIENT_USERS_GET_MANY } from 'api/query-keys';
import type { TSetBlockClientUserReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useSetBlockClientUser = (clientUserId: number) => {
  return useMutationBase<void, unknown, TSetBlockClientUserReq>({
    mutationFn: async (variables) => {
      await http.patch(`/v1/client-user/${clientUserId}/set-block`, variables);
    },

    invalidateCallback: () => [[CLIENT_USERS_GET_MANY]],
  });
};
